import ClientAuth from '@/components/ClientAuth';
import { useAdminContext } from '@/contexts/AdminContext';
import { useAuth } from '@/contexts/AuthContext';
import { useChatSearch } from '@/hooks/useChatSearch';
import { FileItem } from '@common/api/agentService';
import React, { useEffect, useState } from 'react';

const HomePage: React.FC = () => {
    const {
        chat: {
            setCurrentTemplate,
            setSelectedSelector,
            setCurrentConversationId,
            setCurrentResultId,
        },
    } = useAdminContext();
    const {userBilling, user} = useAuth()
    const [inputValue, setInputValue] = useState('');
    const [uploadFiles, setUploadFiles] = useState<FileItem[]>([]);

    const {handleSearch, cancelCurrentRequest} = useChatSearch();
    
    // 每次进入首页时，重置 agent 状态
    useEffect(() => {
        setCurrentTemplate(-1);
        setSelectedSelector('');
        setCurrentResultId('');
    }, [setCurrentTemplate, setSelectedSelector, setCurrentConversationId])

    return (
        <ClientAuth />
    );
};

export default HomePage;
